import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { FormInstance, FormInstanceUpdate } from "domain/entities/form-instance";
import { FormInstanceInputFilter } from "domain/models/nimberforms-input-filters";
import { Logger } from "infra/logger/logger";
import formsinstanceRepository from "infra/repositories/formsinstance-repository";

export const useGetInstanceByFilter = (filter: FormInstanceInputFilter, options?: { enabled?: boolean, retry?: boolean }) => {
    const logger = Logger.getInstance();

    return useQuery({
        queryKey: ["FormsInstace", filter],
        queryFn: async () => {
            try {
                const result = await formsinstanceRepository.getByFilter(filter);
                return result;
            } catch (error: any) {
                if (error instanceof AxiosError) {
                    logger.error(
                    error.response?.data.metadata.errors[0],
                    error.response?.data.metadata
                    );
                throw new Error(error.response?.data.metadata.errors);
                }
                throw error;
            }
        },
        enabled: options?.enabled ?? true,
        retry: options?.retry ?? true,
    });
}

export const useCreateFormsInstanceMutation = () =>{
    const logger = Logger.getInstance();
    const queryFormsInstance = useQueryClient();

    return useMutation({
        mutationFn: async (instance: FormInstance) => {
            const result = await formsinstanceRepository.create(instance);
            return result;
        },
        onSuccess: () => {
            queryFormsInstance.invalidateQueries({queryKey: ["FormsInstance", {}]});
        },
        onError: (error) => {
            if (error instanceof AxiosError) {
                console.log("raw error:", error)
                if (error.response?.data?.metadata?.errors) {
                    const errors = error.response.data.metadata.errors;
                    logger.error(errors[0], error.response?.data.metadata);
                    console.log("error axios",errors[0]);
                    //Cria um objeto de erro com o array de erros como propriedade
                    const customError = new Error("Erro ao criar instance do form");
                    (customError as any).errors = errors; // Adiciona o array de erros ao objeto de erro
                     throw customError;
                } else {
                    throw new Error("Erro desconhecido da API");
                }
            }else {
                logger.error("Erro desconhecido", error);
                throw error;
            }
        }
    });
}

export const useDeleteFormsInstanceMutation = () => {
    const logger = Logger.getInstance();
    const queryFormsInstance = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            if (!id) throw new Error("ID inválido para exclusão");
            const result = await formsinstanceRepository.delete(id);
            console.log(result);
            return result;
        },
        onSuccess: () => {
            queryFormsInstance.invalidateQueries({
                queryKey: [
                "formsinstance",
            ] });
        },
        onError: (error: any) => {
            if (error instanceof AxiosError) {
                logger.error(
                    error.response?.data.metadata.errors[0],
                    error.response?.data.metadata
            );
                throw new Error(error.response?.data.metadata.errors);
            }
            throw error;
        }
    });
};

export const useUpdateFormsInstanceMutation = () => {
  const logger = Logger.getInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: {
      instance: FormInstanceUpdate;
      id: string;
    }) => {
      return await formsinstanceRepository.update(
        data.instance,
        data.id
      );
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["FormsInstance"],
      });
    },

    onError: (error) => {
      if (error instanceof AxiosError) {
        console.log("raw error:", error);

        const errors =
          error.response?.data?.metadata?.errors;

        if (errors?.length) {
          logger.error(errors[0], error.response?.data.metadata);

          console.log("error axios", errors[0]);

          return;
        }
      }

      logger.error("Erro desconhecido", error);
    },
  });
};
